import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { DataService_AppSetup } from "../shared/data.service";

@Component({
	selector: "caass-application-table",
	templateUrl: "./application-table.component.html",
	styleUrls: ["./application-table.component.css"],
})
export class ApplicationTableComponent implements OnInit {
	constructor(private AppTableService: DataService_AppSetup, private dialogService: DialogService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadApplication();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() ApplicationSelected: EventEmitter<any> = new EventEmitter();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedApplication: any;
	lstApplication: any = [];

	//Filter lists
	lstInterfaceTypeDesc: any = [];
	lstIsApplicationInstalledDesc: any = [];
	lstIsBaseInstallDesc: any = [];
	lstInstalledInASchoolDesc: any = [];
	lstMenuItemDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "ApplicationName", header: "Name" },
		{ field: "ApplicationDesc", header: "Description" },
		{ field: "InterfaceTypeDesc", header: "Interface" },
		// { field: 'IsApplicationInstalledDesc', header: 'Installed' },
		// { field: 'IsBaseInstallDesc', header: 'Base Install' },
		// { field: 'InstalledInASchoolDesc', header: 'Installed in a School' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadApplication() {
		this.SelectedApplication = null;

		this.loading = true;

		var result = this.AppTableService.ApplicationTableSelectList();
		result.subscribe(
			(response) => {
				this.lstApplication = response;

				//Load Data Filter Lists
				this.lstInterfaceTypeDesc = Array.from(new Set(this.lstApplication.map((item: any) => item.InterfaceTypeDesc))).sort();
				this.lstIsApplicationInstalledDesc = Array.from(new Set(this.lstApplication.map((item: any) => item.IsApplicationInstalledDesc))).sort();
				this.lstIsBaseInstallDesc = Array.from(new Set(this.lstApplication.map((item: any) => item.IsBaseInstallDesc))).sort();
				this.lstInstalledInASchoolDesc = Array.from(new Set(this.lstApplication.map((item: any) => item.InstalledInASchoolDesc))).sort();
				this.lstMenuItemDesc = Array.from(new Set(this.lstApplication.map((item: any) => item.MenuItemDesc))); ///

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadApplication();
	}

	//Custom Button Methods

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedApplication = val.data;

		this.ApplicationSelected.emit(this.SelectedApplication.ApplicationID);
	}
	onRowUnselect(val) {
		this.SelectedApplication = null;

		this.ApplicationSelected.emit("");
	}
	onRowDblClick(Application) {
		this.SelectedApplication = Application;

		this.ApplicationSelected.emit(this.SelectedApplication.ApplicationID);
	}
	////////////////////////////////////////////
}
